<script setup lang="ts">
import { ref } from "vue";

const focusPlan = ref(2);
</script>

<template>
  <div>
    <div class="card p-3 m-2">
      <div class="btn-group mb-4" role="group" aria-label="Legend selector">
        <input
          type="radio"
          class="btn-check"
          name="focusPlan"
          id="focusPlan1"
          autocomplete="off"
          v-model="focusPlan"
          :value="1"
        />
        <label class="btn btn-outline-secondary" for="focusPlan1"
          >Downstairs</label
        >

        <input
          type="radio"
          class="btn-check"
          name="focusPlan"
          id="focusPlan2"
          autocomplete="off"
          v-model="focusPlan"
          :value="2"
        />
        <label class="btn btn-outline-secondary" for="focusPlan2"
          >Upstairs</label
        >

        <input
          type="radio"
          class="btn-check"
          name="focusPlan"
          id="focusPlan3"
          autocomplete="off"
          v-model="focusPlan"
          :value="3"
        />
        <label class="btn btn-outline-secondary" for="focusPlan3"
          >The Tower</label
        >

        <input
          type="radio"
          class="btn-check"
          name="focusPlan"
          id="focusPlan4"
          autocomplete="off"
          v-model="focusPlan"
          :value="4"
        />
        <label class="btn btn-outline-secondary" for="focusPlan4"
          >EG Trefoil (A56)</label
        >
      </div>
      <img
        v-if="focusPlan === 1"
        src="../assets/plan_downstairs.svg"
        alt="Floor plan downstairs missing."
      />
      <img
        v-if="focusPlan === 2"
        src="../assets/plan_upstairs.svg"
        alt="Floor plan upstairs missing."
      />
      <img
        v-if="focusPlan === 3"
        src="../assets/plan_tower.svg"
        alt="Floor plan tower missing."
      />
      <img
        v-if="focusPlan === 4"
        src="../assets/A56_EG.svg"
        alt="Floor plan AE56 EG missing."
      />
    </div>
  </div>
</template>

<style scoped></style>
